import api from "service/api"

const fetchUserDetails = async () => {
  try {
    const res = await api.get(`/api/scholarRoute?path=student/basic`)
    if (res.data.success) {
      return res.data.data
    } else {
      throw new Error(res.data.message)
    }
  } catch (err: any) {
    console.log(err)
    throw new Error("Something went wrong. Please try after some time")
  }
}

const fetchDETUserDetails = async () => {
  try {
    const res = await api.get(`/api/scholarRoute?path=det-elite/details`)
    if (res.data.success) {
      return res.data.data
    } else {
      console.log("Error in fetching user details")
      return null
    }
  } catch (err: any) {
    console.log(err)
    return null
  }
}

export const referAndEarnApi = {
  fetchUserDetails,
  fetchDETUserDetails,
}
